import { mapState } from 'vuex';
import BaseProductSlider from './components/BaseProductSlider.vue';
import EventBusConfig from './config/eventBusConfig';
import router from './router';
import store, { types } from './store';
import { EventBus, Vue } from './vue';
import getFrontConfig from '../common/getFrontConfig';

const debounce = require('lodash/debounce');
const isMatchedBreakpoint = require('../common/utils/isMatchedBreakpoint');

const FRONT_CONFIG = getFrontConfig();
let instances = [];

const cartRecommendationsBreakpoint = FRONT_CONFIG.responsive.bp_575;

function createInstance(element) {
  // eslint-disable-next-line no-unused-vars
  const vm = new Vue({
    el: element,
    computed: mapState({
      products: (state) => state.cart.recommendations,
    }),
    render(h) {
      return h(BaseProductSlider, {
        /* Add class property to save the original classlist of the div, in
        order to destroy and create instances with the same selector (the same
        css class that is used to query in the DOM) */
        class: 'cart-content__recommended-products',
        props: {
          heading: this.$msg('whatabout.title', 'product'),
          products: this.products,
          tileContext: FRONT_CONFIG.vue.BaseProductTile.context.minicartSlider,
        },
      });
    },
    router,
    store,
  });

  instances.push(vm);
}

/**
 * Get the Einstein Recommendation HTML Elements
 * @returns {NodeList} The recommendation HTML elements
 */
function getRecommendationElements() {
  const isDesktop = isMatchedBreakpoint.matches(
    `bp_${cartRecommendationsBreakpoint}`,
    'min-width'
  );
  const cartRecommendedProductsSelector = isDesktop
    ? '.cart-content__recommended-products-container--desktop .cart-content__recommended-products'
    : '.cart-content__recommended-products-container--mobile .cart-content__recommended-products';
  return document.querySelectorAll(cartRecommendedProductsSelector);
}

/**
 * Create all instances for the recommendationElements
 * @param {NodeList} recommendationElements The HTML Element containers of the cart recommendations
 */
function createAllInstances(recommendationElements) {
  [...recommendationElements].forEach(createInstance);
}

/**
 * Create the vue cart recommendations instances
 */
function createRecommendations() {
  const vueCartRecommendations = getRecommendationElements();
  // If it is not found, then abort the creation of Vue instance
  if (!vueCartRecommendations || vueCartRecommendations.length === 0) return;

  store.dispatch(types.cart.loadRecommendations);
  createAllInstances(vueCartRecommendations);
}

function removeRecommendations() {
  instances.forEach((vm) => vm.$destroy());
  instances = [];
}

function initCartRecommendations() {
  // createAllInstances();
  EventBus.$on(
    EventBusConfig.commands.cart.removeRecommendationVueInstances,
    removeRecommendations
  );
  EventBus.$on(
    EventBusConfig.commands.cart.createRecommendationVueInstances,
    createRecommendations
  );
  // eslint-disable-next-line listeners/no-missing-remove-event-listener
  window.addEventListener(
    'resize',
    debounce(() => {
      EventBus.$emit(
        EventBusConfig.commands.cart.removeRecommendationVueInstances
      );
      EventBus.$emit(
        EventBusConfig.commands.cart.createRecommendationVueInstances
      );
    }, 500)
  );
}

export default initCartRecommendations;
